import { collection, onSnapshot, query, where } from 'firebase/firestore';
import {
    INSTRUCTION_HISTORY,
    INSTRUCTION_SUGGESTIONS,
    USER_SIGNATURES,
} from 'utils/config/constants/controllerNames';
import {
    setInstructionHistory,
    setUserSignature,
    setInstructionSuggestions,
} from 'store/global/globalSlice';
import { errorLogger } from 'utils/config/firebase/logs';
import { InstructionHistoryType, SuggestionType, UserSignatureType } from 'store/global/types';
import { auth, db } from 'utils/config/firebase';
import { AppDispatch } from 'store';
import { sanitizeAndDeleteHtml } from 'helpers/htmlParser';

export const getSignatureQuery = (dispatch: AppDispatch) => {
    try {
        const collectionRef = collection(db, USER_SIGNATURES);
        const q = query(collectionRef, where('user_id', '==', auth?.currentUser?.uid));
        onSnapshot(q, (snapshot) => {
            if (snapshot.docs[0]) {
                const data = {
                    ...snapshot.docs[0].data(),
                    documentId: snapshot.docs[0].id,
                } as UserSignatureType;

                // sanitize to prevent XSS
                for (const [key, value] of Object.entries(data)) {
                    data[key] = sanitizeAndDeleteHtml(value);
                }

                dispatch(setUserSignature(data));
            }
        });
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'getSignatureQuery');
        }
        console.log(error);
    }
};

export const getInstructionSuggestionsQuery = (dispatch: AppDispatch) => {
    try {
        const unsubscribe = onSnapshot(collection(db, INSTRUCTION_SUGGESTIONS), (snapshot) => {
            const formattedData: SuggestionType[] = snapshot.docs.map((doc) => ({
                id: doc.id,
                title: doc.data().title,
                prompt: doc.data().prompt,
            }));
            dispatch(setInstructionSuggestions(formattedData));
        });
        return unsubscribe;
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'getInstructionSuggestionsQuery');
        }
        console.log(error);
    }
};

export const getInstructionHistoryQuery = (dispatch: AppDispatch) => {
    try {
        const collectionRef = collection(db, INSTRUCTION_HISTORY);
        const q = query(collectionRef, where('user_id', '==', auth?.currentUser?.uid));
        onSnapshot(q, (snapshot) => {
            if (snapshot.docs[0]) {
                const filteredData: InstructionHistoryType[] = snapshot.docs
                    .map((doc) => ({
                        value: doc.data().value,
                        created_at: doc.data().created_at,
                        document_id: doc.id,
                    }))
                    .sort(
                        (a, b) =>
                            new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
                    )
                    .slice(0, 5);
                dispatch(setInstructionHistory(filteredData));
            }
        });
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'getInstructionHistoryQuery');
        }
        console.log(error);
    }
};
